const API_URL = process.env.REACT_APP_API_URL;

// Helper function to handle common fetch operations
const fetchWithAuth = async (url, options = {}) => {
  // Get the authentication token from localStorage
  const token = localStorage.getItem("token");

  // Set up headers with authentication
  const headers = {
    "Content-Type": "application/json",
    ...(token && { Authorization: `Bearer ${token}` }),
    ...options.headers,
  };

  // Perform the fetch operation
  const response = await fetch(url, {
    ...options,
    headers,
  });

  // Handle non-OK responses
  if (!response.ok) {
    throw new Error(`API Error: ${response.statusText}`);
  }

  return response.json();
};

// Team Members API
export const fetchTeamMembers = async () => {
  return fetchWithAuth(`${API_URL}/team-members`);
};

export const getTeamMemberById = async (id) => {
  return fetchWithAuth(`${API_URL}/team-members/${id}`);
};

export const createTeamMember = async (teamMemberData) => {
  return fetchWithAuth(`${API_URL}/team-members`, {
    method: "POST",
    body: JSON.stringify(teamMemberData),
  });
};

export const updateTeamMember = async (id, teamMemberData) => {
  return fetchWithAuth(`${API_URL}/team-members/${id}`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(teamMemberData),
  });
};

export const deleteTeamMember = async (id) => {
  return fetchWithAuth(`${API_URL}/team-members/${id}`, {
    method: "DELETE",
  });
};
